import { NavMarker } from 'react-rhumb';
import { useSignupEmbedder } from 'signup-embedder/hooks/useSignupEmbedder';
import styled from 'styled-components';
import { AnimatedStepBody } from '../animation/StepBodyAnimations';
import { LayoutTemplateContentContainer } from '../app/AppViewComponent.styles';
import { ExperimentKeys } from '../experiments/ExperimentKeys';
import { TrackWhen, useExperiment } from '../experiments/useExperiment';
import { getFlowConfig } from '../flow-initial/getFlowConfig';
import { useLayoutTemplate } from '../hooks/useLayoutTemplate';
import { OAuthSignupSection } from '../oauth/OAuthSignupSection';
import { useResponsiveness } from '../responsiveness/ResponsivenessProvider';
import { Data } from 'signup-constants/signupData/Data';
import { SignupDataInputForm } from '../signup-data/SignupDataInputForm';
import CreateAccountTermsOfService from '../views-components/CreateAccountTermsOfService';
import PrivacyBanner from '../views-components/PrivacyBanner';
import { Step } from 'signup-constants/Step';
import { HaveAnAccountLink } from './HaveAnAccountLink';
import { LandingPageTitle } from './LandingPageTitle';
import { getLandingPageButton } from './getLandingPageText';
import { useLandingPage } from './useLandingPage';
import WideLandingPageView from './WideLandingPage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const EmbeddedHaveAnAccount = styled.div.withConfig({
  displayName: "LandingPageView__EmbeddedHaveAnAccount",
  componentId: "sc-176kln1-0"
})(["", ""], props => props.theme.embedded && `
      margin-top: 1.5rem;
      font-size: 14px;
      margin-bottom: 1.5rem;
    `);
const LandingPageView = () => {
  const stepKey = Step.LandingPage;
  const {
    shouldShowTosOnLandingPage: shouldShowTermsOfService,
    shouldShowSignInButton
  } = getFlowConfig();
  const {
    chooseEmailSignUp
  } = useLandingPage(stepKey);
  const {
    isMobile
  } = useResponsiveness();
  const {
    isActive: isInstanceOfSignupEmbedder
  } = useSignupEmbedder();
  const {
    layoutType
  } = useLayoutTemplate();
  const {
    isAssignedToVariant: isACQ0143Variant
  } = useExperiment(ExperimentKeys.ACQ0143, TrackWhen.enrolled);
  useExperiment(ExperimentKeys.ACQ0142, TrackWhen.assignedToControlOrVariantA, true);
  useExperiment(ExperimentKeys.ACQ0144, TrackWhen.enrolled, true);
  useExperiment(ExperimentKeys.WP0078, TrackWhen.enrolled, true);
  const Footer = () => {
    return isInstanceOfSignupEmbedder ? /*#__PURE__*/_jsxs(EmbeddedHaveAnAccount, {
      className: "text-center",
      children: [shouldShowSignInButton && /*#__PURE__*/_jsx(HaveAnAccountLink, {}), /*#__PURE__*/_jsx(PrivacyBanner, {})]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(PrivacyBanner, {}), shouldShowTermsOfService && /*#__PURE__*/_jsx(CreateAccountTermsOfService, {})]
    });
  };
  return /*#__PURE__*/_jsx(NavMarker, {
    name: Step.LandingPage,
    children: /*#__PURE__*/_jsx(AnimatedStepBody, {
      animationDelay: true,
      children: /*#__PURE__*/_jsx("div", {
        "data-selenium": `${stepKey}_VIEW`,
        children: isACQ0143Variant() ? /*#__PURE__*/_jsx(WideLandingPageView, {}) : /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(LandingPageTitle, {
            isMobile: isMobile
          }), /*#__PURE__*/_jsxs(LayoutTemplateContentContainer, {
            layoutType: layoutType,
            shouldRestrictWidth: true,
            children: [/*#__PURE__*/_jsx(OAuthSignupSection, {}), /*#__PURE__*/_jsx(SignupDataInputForm, {
              autoFocus: false,
              buttonProps: {
                label: getLandingPageButton()
              },
              dataKey: Data.Email,
              inputMode: 'email',
              shouldTrimData: true,
              submit: chooseEmailSignUp
            }, Data.Email), /*#__PURE__*/_jsx(Footer, {})]
          })]
        })
      })
    })
  });
};
export default LandingPageView;